var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJourneyMenuIcon = function SvgJourneyMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5c34cd",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3A1.5 1.5 0 0 0 3 4.5v2.402a1.5 1.5 0 0 0 1.5 1.5h2.402a1.5 1.5 0 0 0 1.5-1.5V4.5a1.5 1.5 0 0 0-1.5-1.5zM11.098 3a1.5 1.5 0 0 0-1.5 1.5v2.402a1.5 1.5 0 0 0 1.5 1.5H13.5a1.5 1.5 0 0 0 1.5-1.5V4.5A1.5 1.5 0 0 0 13.5 3zM9.597 11.097a1.5 1.5 0 0 1 1.5-1.5H13.5a1.5 1.5 0 0 1 1.5 1.5V13.5a1.5 1.5 0 0 1-1.5 1.5h-2.403a1.5 1.5 0 0 1-1.5-1.5zM4.5 9.598a1.5 1.5 0 0 0-1.5 1.5V13.5A1.5 1.5 0 0 0 4.5 15h2.402a1.5 1.5 0 0 0 1.5-1.5v-2.402a1.5 1.5 0 0 0-1.5-1.5z"
  })));
};
export default SvgJourneyMenuIcon;